export default __webpack_public_path__ + "static/media/cover-card-display-impression.f7df17ed.svg";